/** Тексты этапа 1.1: вход, виджет «Идея / Проблема», уведомления, пользователи, журнал. Паритет с ru/extra.ts — npm run i18n:check. */
export default {
  ui: {
    loading: 'Loading…',
    error: 'Something went wrong',
    retry: 'Retry',
    empty: 'Nothing here yet',
    saving: 'Saving…',
    saved: 'Saved',
    copy: 'Copy',
    copied: 'Copied',
    never: 'Never',
  },
  auth: {
    google: 'Sign in with Google',
    or: 'or',
    accessByInvite: 'Access is by invitation only. Ask your Treejar manager.',
    staffHint: 'Treejar staff sign in here too and are taken to the Partner Hub.',
    inviteTitle: 'Set your password',
    inviteBody: 'You were invited as {{role}}{{partner}}. Choose a password for {{email}}.',
    inviteBodyPartner: ' at {{partner}}',
    resetTitle: 'New password',
    resetBody: 'Choose a new password for {{email}}.',
    name: 'Your name',
    newPassword: 'New password',
    confirmPassword: 'Repeat password',
    passwordRule: 'At least 8 characters.',
    passwordMismatch: 'Passwords do not match.',
    activate: 'Set password and sign in',
    forgotTitle: 'Reset your password',
    forgotBody: 'Enter your work email — if it is registered, we will send a link to set a new password.',
    forgotSubmit: 'Send reset link',
    forgotSent: 'If {{email}} is registered, a reset link is on its way. Check your inbox.',
    signOut: 'Sign out',
    errors: {
      invalid_credentials: 'Email or password is not recognised. Check the details or reset your password.',
      user_disabled: 'This account is disabled. Contact your Treejar manager.',
      not_invited: 'Access is by invitation only. Ask your Treejar manager to invite {{email}}.',
      state: 'The sign-in session expired, please try again.',
      email: 'Google did not confirm your email address.',
      invite_invalid: 'This link is invalid or has expired. Ask for a new invitation.',
      password_weak: 'The password must be at least 8 characters.',
      network: 'Cannot reach the server. Check your connection and try again.',
      google_not_configured: 'Google sign-in is not configured yet.',
      redirect_uri_mismatch: 'Google OAuth is missing the return address of this site.',
      session_invalid: 'Your session has expired, please sign in again.',
      generic: 'Sign-in failed: {{code}}',
    },
  },
  fb: {
    button: 'Idea / Problem',
    title: 'Idea / Problem',
    close: 'Close',
    kind: { bug: 'Problem', net: 'Missing', mesh: 'Annoying', idea: 'Idea', feat: 'Feature' },
    placeholderBug: 'What happened, what you expected and what you saw',
    placeholderIdea: 'Describe what you would like to change or add',
    attachShot: 'Attach a screenshot of this screen',
    orFile: 'or your own file:',
    screen: 'Screen: {{screen}}',
    capturing: 'Capturing the screen…',
    sending: 'Sending…',
    send: 'Send',
    thanks: 'Thank you! Feedback #{{id}} received.',
    thanksHint: 'We reply inside the feedback card; you get a notification when it is fixed.',
    myItems: 'My feedback',
    failed: 'Could not send. Please try again.',
    myTitle: 'My feedback',
    mySubtitle: 'Ideas and problems you reported, with their status. Accept a fix or return it to work with a comment.',
    boardHint: 'Statuses: request → in work → fixed (awaiting your check) → accepted. The author accepts a fix with “Accept” or returns it with a comment.',
    filter: { open: 'open', awaiting: 'awaiting check', closed: 'closed', all: 'all' },
    onlyMine: 'only mine',
    sideAll: 'Treejar and partners',
    sideTreejar: 'Treejar',
    sidePartner: 'Partner',
    col: { status: 'Status', type: 'Type', summary: 'Summary', screen: 'Screen', author: 'Author', when: 'When', side: 'Side', priority: 'Priority' },
    empty: 'No feedback in this filter',
    selectHint: 'Select an item on the left',
    comments: '{{n}} comments',
    robot: 'robot: {{state}}',
    note: 'Admin note',
    robotNote: 'Robot',
    history: 'History',
    commentPlaceholder: 'Comment or question',
    sendComment: 'Send comment',
    accept: 'Accept',
    returnToWork: 'Return to work',
    status: { new: 'Fix requested', work: 'In work', testing: 'Fixed', done: 'Accepted', reject: 'Rejected' },
    priority: { low: 'low', normal: 'normal', high: 'high', critical: 'critical' },
    runFix: 'Start fixing',
    runFixHint: 'The robot on the server takes the item, fixes the code, deploys and reports back',
    queued: 'In robot queue',
    running: 'Robot is working…',
    createIssue: 'Create task',
    issueCreated: 'GitHub task created',
    screenshot: 'screenshot',
    system: 'system',
    eventStatus: 'status {{from}} → {{to}}',
    eventPriority: 'priority {{from}} → {{to}}',
    eventFix: 'robot: {{state}}',
    eventIssue: 'GitHub task created',
    eventComment: 'comment',
    kindsHint: 'Types: {{kinds}}',
  },
  bell: {
    filterOther: 'Other',
    loadError: 'Could not load notifications',
  },
  users: {
    inviteTitle: 'Invite a Treejar colleague',
    inviteSub: 'They receive an email with a link to set a password; they can also sign in with Google using this address.',
    email: 'Work email',
    name: 'Full name',
    role: 'Role',
    locale: 'Email language',
    send: 'Send invitation',
    sent: 'Invitation sent to {{email}}',
    inviteLink: 'Invitation link (if the email does not arrive):',
    reinvite: 'Resend invitation',
    disable: 'Disable',
    enable: 'Enable',
    approveMargin: 'Can approve below-minimum margin',
    approveLoss: 'Can approve loss-making deals',
    statusDisabled: 'Disabled',
    you: 'you',
    roleFinance: 'Finance',
  },
  audit: {
    title: 'Operations log',
    sub: 'Append-only log of logins, invitations, settings and data changes. Nothing can be edited or deleted.',
    when: 'When',
    who: 'Who',
    side: 'Side',
    entity: 'Entity',
    action: 'Action',
    details: 'Details',
    filterEntity: 'Entity',
    filterActor: 'Actor',
    empty: 'No records',
    sideTreejar: 'Treejar',
    sidePartner: 'Partner',
    sideSystem: 'System',
  },
  impX: {
    pagesHint: '{{count}} pages',
    rowsHint: '{{count}} rows',
    profile: 'Import profile',
    profileGeneric: 'Generic mode (no profile)',
    profileHint: 'Partner rules apply: two-price meaning, special-offer sections, shared stock cells.',
    genericHint: 'Only explicit fields are extracted; every row must be reviewed by hand.',
    contractMissing: 'Contract is not active ({{status}}) — publishing will be blocked',
    uploading: 'Uploading…',
    prevMeta: 'v{{version}} · {{date}}',
    prevItems: '{{count}} items',
    noPrev: 'No published price list for this partner yet.',
    draftsAllTitle: 'Unfinished imports',
    draftsAllSub: 'Drafts of all suppliers: continue the review or publication.',
    historySub: 'Published and superseded price list versions of all suppliers.',
    historyEmpty: 'No imports yet.',
    openVersion: 'Open',
    draftsTitle: 'Unfinished imports for this partner',
    hasErrors: 'with errors',
    continueReview: 'Continue review',
    continueExtraction: 'Open extraction',
    uploadError: { bad_file_type: 'Unsupported file type. Use PDF, XLSX, CSV, JPG or PNG.', file_too_large: 'The file is larger than 40 MB.', profile_mismatch: 'This profile belongs to another partner.', network: 'Cannot reach the server.' },
    statRisk: 'Risk, AED',
    retryExtraction: 'Run extraction again',
    pageFailed: 'not read',
    modeLabel: 'Mode',
    mode: { profile: 'Partner profile', generic: 'Generic', table: 'Table (no AI)' },
    modelLabel: 'Model',
    costLabel: 'Cost',
    pendingBanner: '{{count}} rows still need a manual check · total risk AED {{risk}}',
    allReviewed: 'All mandatory rows are checked.',
    showPending: 'Show unchecked',
    reviewAll: 'Checked: rows without remarks',
    reviewAllHint: 'Marks rows with no check flags, recognition confidence ≥ 85 % and risk below the threshold as checked. Rows with remarks stay for manual review.',
    reviewForce: 'Mark all {{count}} as checked (admin)',
    reviewForceHint: 'Marks mandatory rows too, without verification — for a trusted price list or a walkthrough. The action is logged.',
    reviewMarked: 'Marked as checked: {{count}}. Left for manual review: {{pending}}.',
    reviewRuleNote: 'No remarks = no check flags, confidence ≥ 85 %, risk below the settings threshold. Confirm the yellow rows yourself: open the item and press «Mark as reviewed».',
    includeHint: 'Include in publication',
    colRisk: 'Risk, AED',
    colFlags: 'Checks',
    colReviewed: 'Checked',
    required: 'required',
    optional: 'optional',
    edited: 'edited',
    special: 'special',
    discontinued: 'discontinued',
    setPrice: 'set price',
    compare: 'Compare with catalog',
    flag: {
      price_invalid: 'no price', price_jump: 'price jump >20%', price_outlier: 'price outlier', pass_mismatch: 'passes differ', qty_invalid: 'bad quantity', pool_inconsistent: 'shared stock differs',
      option_suspicious: 'option surcharge >50%', discount_conflict: 'discount ≠ contract', duplicate_conflict: 'duplicate differs', two_prices: 'two prices — choose', no_cbm: 'no CBM', new_item: 'new item',
    },
    diffTitle: 'Changes versus the current catalog (v{{version}})',
    publishSub: 'Products, stock lots and prices are updated; quoted specifications, reservations and POs keep their snapshots.',
    blockersTitle: 'Publishing is blocked until:',
    blockContract: 'the partner contract is signed and active',
    blockReview: '{{count}} mandatory rows are checked',
    blockPrice: '{{count}} rows get a price',
    blockApproval: 'an admin approves the version (total risk AED {{risk}} ≥ second-approval threshold)',
    approveBtn: 'Approve as admin',
    approved: 'Second approval given by an admin.',
    confirmNote: 'The previous version becomes Superseded. Existing quotes, reservations and purchase orders keep their prices.',
    doneBody: '{{count}} items from {{partner}} are now in the catalog: {{added}} new, {{removed}} removed, {{changed}} price or stock changes. Specifications quoted before today keep their original prices.',
    statStockUnits: 'Units in stock',
    publishError: { review_pending: 'Some mandatory rows are not checked yet.', missing_price: 'Some rows have no price.', second_approval_required: 'An admin must approve this version first.', contract_required: 'The partner contract is not active.', not_draft: 'This version is already published.' },
  },
  perm: {
    title: 'What each role can open and change',
    sub: 'Five roles stay the same; here the admin decides, section by section, whether a role sees nothing, reads, or edits. Checks run on the server and in the database — the screen only hides menu items and buttons. Admin always has everything and cannot be restricted.',
    save: 'Save permissions',
    reset: 'Back to defaults',
    saved: 'Role permissions saved',
    readOnlyNote: 'Only an admin can change this matrix. You see it for reference.',
    adminLocked: 'Admin always has full access',
    colArea: 'Section',
    colAction: 'Action',
    level: { none: 'No access', read: 'View', write: 'Edit' },
    area: { dashboard: 'Dashboard', partners: 'Partners', import: 'Price list import', catalog: 'Catalog', specifications: 'Specifications', purchase_orders: 'Purchase orders', feedback: 'Feedback', settings: 'Settings', users: 'Users' },
    areaHint: {
      dashboard: 'Home screen with summary numbers',
      partners: 'Partner cards, onboarding, preview, contracts, site scan',
      import: 'Upload and review price lists',
      catalog: 'Products and listings',
      specifications: 'Client specifications',
      purchase_orders: 'Purchase orders from Zoho',
      feedback: 'Ideas / problems board',
      settings: 'Workspace settings and site integration; Edit lets the role change them',
      users: 'Staff list; Edit lets the role invite, change roles and disable people',
    },
    actionsTitle: 'Separate actions',
    actionsSub: 'Sensitive steps that are allowed on top of section access. A role needs Edit on the matching section as well.',
    action: { publish_prices: 'Publish a price list', second_approval: 'Approve a high-risk price list', send_to_site: 'Send listings to the website', sign_contracts: 'Send and sign contracts', zoho_sync: 'Run Zoho sync' },
    actionHint: {
      publish_prices: 'Turns a reviewed draft into the live price list of the partner',
      second_approval: 'Second signature when the total risk exceeds the threshold in Pricing rules',
      send_to_site: 'Publish, archive and push availability to treejartrading.ae',
      sign_contracts: 'Send the contract to the partner, sign it, upload a scan',
      zoho_sync: 'Pull purchase orders from Zoho Books on demand',
    },
    howTitle: 'How to give a colleague access',
    how1: 'Users & roles → Invite: enter the Google e-mail the person signs in with and pick a role.',
    how2: 'The person opens market.starec.ai → «Sign in with Google» with that e-mail. No password needed.',
    how3: 'Here you decide what that role sees and edits. Changes apply at the next request — no re-login needed.',
    openMatrix: 'Open the permissions matrix',
    googleHint: 'Sign-in is by Google account: the invited e-mail must match the Google e-mail letter for letter.',
    noAccessTitle: 'No access to this section',
    noAccessBody: 'Your role does not include this section. Ask an admin to change it in Settings → Role permissions.',
  },
  sp: {
    belowMinResale: 'Price is below the partner minimum resale price — rejected by the database, approval does not bypass it',
    blocked: 'Blocked: {{list}}',
    blocker: {
      no_lines: 'no line items',
      no_price: 'a line has no price',
      approval_below_min: 'margin or contribution below threshold — approval required',
      approval_loss: 'negative contribution — loss approval required',
      no_cbm: 'items without CBM — enter pickup and delivery costs manually',
    },
    lineAdded: '{{sku}} added',
    go: { Draft: 'Back to draft', Quoted: 'Send quote', Won: 'Mark won', Lost: 'Mark lost', Cancelled: 'Cancel' },
    quoteValid: 'quote valid until {{date}}',
    repriced: 'Recalculated at the current price list',
    reprice: 'Recalculate at current price list',
    repriceHint: 'Quoted specifications keep their cost and price snapshots; this replaces them with the current price list and is logged.',
    statusChanged: 'Status: {{status}}',
    lockedNote: 'This specification is closed — lines and prices are read-only.',
    frozenNote: 'Quoted: cost and price snapshots are frozen. A new price list does not change them — use «Recalculate at current price list».',
    siteAddress: 'Site address',
    quickAddSku: 'Add by SKU',
    add: 'Add',
    colContribution: 'Contribution',
    noCbmTag: 'no CBM',
    priceBasis: { old_stock: 'old-stock price', new: 'new-stock price', mixed: 'mixed lots (FIFO)' },
    now: 'now {{value}}',
    nowCostHint: 'Cost at the current price list differs from the snapshot',
    manualPriceHint: 'Manual price; clear to return to the calculated {{value}}',
    minResaleHint: 'Minimum resale price: {{value}}',
    costsTitle: 'Direct costs',
    costsSub: 'Estimate by tariffs (Settings → Costs & approvals): pickup per trip, delivery per CBM, installation per unit. Type a plan amount to override it; enter actuals after execution.',
    noCbm: 'No CBM: {{skus}} — delivery and pickup cannot be estimated',
    colCost: 'Cost',
    basis: 'Basis',
    plan: 'Plan',
    actual: 'Actual',
    delta: 'Δ',
    cost: { pickup: 'Pickup from partner', delivery: 'Delivery to client', installation: 'Installation', other: 'Other' },
    manualOverride: 'manual estimate',
    deliveryBasis: '{{cbm}} m³ × {{rate}} AED, min {{min}}',
    otherHint: 'parking, hoisting, night work — enter manually',
    resetEstimateHint: 'Clear the field to return to the tariff estimate',
    overrideHint: 'Type an amount to override the tariff estimate',
    actualHint: 'Actual amount after execution (carrier invoice, installer timesheet)',
    directCosts: 'Direct costs',
    contribution: 'Contribution after direct costs',
    contributionPct: 'Contribution %',
    contributionActual: 'Contribution (actual)',
    approvalTitle: 'Approval',
    approvalNotNeeded: 'Margin and contribution are above the thresholds — no approval needed.',
    approvalNeeded: {
      below_min: 'Product margin or contribution is below the threshold. Quoted and Won are blocked until approved.',
      loss: 'Contribution after direct costs is negative — the deal is at a loss. Only a staff member with the loss-approval flag can approve.',
    },
    approvalOk: 'Approved for this version.',
    approvalPending: 'Requested by {{who}} — waiting for a decision.',
    approved: 'Approved',
    rejected: 'Rejected',
    approve: 'Approve',
    reject: 'Reject',
    whoApproves: { below_min: 'Approvers: admin or staff with the margin-approval flag.', loss: 'Approver: staff with the loss-approval flag (by default the Chairman of the Board).' },
    reasonPlaceholder: 'Reason (e.g. strategic client)',
    approvalRequested: 'Approval requested',
    requestApproval: 'Request approval',
    level: { below_min: 'below threshold', loss: 'loss' },
    approvalStatus: { Pending: 'pending', Approved: 'approved', Rejected: 'rejected', Invalidated: 'reset by a change' },
    poLater: 'Purchase orders are created from a confirmed specification in stage 1.5. The split by partner is shown here so the totals can be checked now.',
  },
  costs: {
    saved: 'Costs & approvals saved',
    title: 'Costs & approvals',
    sub: 'Tariffs for the direct-cost estimate, approval thresholds and markup rules by category or partner. Applied to every new calculation; saved snapshots of quoted specifications do not change.',
    thresholdsTitle: 'Approval thresholds',
    thresholdsSub: 'Below these values a specification cannot be quoted or won without approval.',
    minMargin: 'Minimum product margin',
    minContribution: 'Minimum contribution after direct costs',
    whoApproves: 'Below threshold with contribution ≥ 0 — admin or a user with the margin-approval flag. Negative contribution — only a user with the loss-approval flag (Settings → Users).',
    ratesTitle: 'Pickup and delivery tariffs',
    ratesSub: 'Pickup: trips = ⌈CBM of the partner\'s lines / vehicle capacity⌉ × rate. Delivery: CBM of the specification × rate, not less than the minimum.',
    pickupTrip: 'Pickup, AED per trip',
    vehicleCbm: 'Vehicle capacity, CBM',
    deliveryCbm: 'Delivery, AED per CBM',
    deliveryMin: 'Delivery minimum, AED',
    installTitle: 'Installation per unit',
    installSub: 'AED per unit by category; categories without a tariff are not installed.',
    addRow: 'Add',
    rulesTitle: 'Markup rules',
    rulesSub: 'Override the default markup for a category, a partner or a partner + category pair.',
    scope: { category: 'Category', partner: 'Partner', partner_category: 'Partner + category' },
    noRules: 'No rules — partner markup or the workspace default applies.',
    rulesOrder: 'Priority: item markup → partner + category → partner → category → partner default → workspace default.',
  },
};
